import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

export const organizersStoreSelector = (state: RootState) => state.organizers;

export const selectPlansList = createSelector([organizersStoreSelector], (state) => state.plans.list);
